import React from 'react';
import { FaFilePdf } from 'react-icons/fa';
import demo1 from '../../assets/documents/TMonumentsandArchaeological.pdf';
import demo2 from '../../assets/documents/Treasuretrove.pdf';
import demo3 from '../../assets/documents/Indiantreasure.pdf';
import demo4 from '../../assets/documents/RighInformation.pdf';
import demo5 from '../../assets/documents/AntiquitiesandArt.pdf';
import demo6 from '../../assets/documents/SitesandRemains.pdf';
import demo11 from '../../assets/documents/TMonumentsandArchaeologicalMarathi.pdf';
import demo12 from '../../assets/documents/TreasuretroveMarathi.pdf';
import demo13 from '../../assets/documents/IndiantreasureMarathi.pdf';
import demo14 from '../../assets/documents/RighInformationMarathi.pdf';
import demo15 from '../../assets/documents/AntiquitiesandArtMarathi.pdf';
import demo16 from '../../assets/documents/SitesandRemainsMarathi.pdf';
import { useSelector } from 'react-redux';
import { convertToMarathiNumber } from '../../components/marathiNumbers';
import { Link } from 'react-router-dom';

const Actsandlaws = () => {
    const selectedLang = useSelector((state) => state.language.selectedLang);

    const content = {
        English: {
            title: "Legislations",
            breadcrumb: {
                home: "HOME",
                page: "LEGISLATIONS",
            },
        },
        मराठी: {
            title: "अधिनियम ",
            breadcrumb: {
                home: "मुख्यपृष्ठ ",
                page: "अधिनियम ",
            },
        },
    };
    const t = content[selectedLang];
    const tableHeaders = {
        srNo: {
            English: "Sr. No.",
            मराठी: "अ.क्र.",
        },
        name: {
            English: "Name",
            मराठी: "नाव",
        },
        download: {
            English: `Download`,
            मराठी: `डाउनलोड`,
        },
    };
    const documents = [
        {
            id: 1,
            name: {
                English: "The Maharashtra Ancient Monuments and Archaeological Sites and Remains Rules, 1962",
                मराठी: "महाराष्ट्र प्राचीन स्मारके आणि पुरातत्त्व स्थळे व अवशेष नियम, १९६२",
            },
            file: {
                English: demo1,
                मराठी: demo11,
            },
        },
        {
            id: 2,
            name: {
                English: "The Indian Treasure Trove (Extension to the Hyderabad and Saurashtra Areas of Bombay State) Act, 1957",
                मराठी: "भारतीय खजिना कायदा (हैदराबाद आणि सौराष्ट्र प्रदेशासाठी विस्तार), १९५७",
            },
            file: {
                English: demo2,
                मराठी: demo12,
            },
        },
        {
            id: 3,
            name: {
                English: "The Indian Treasure Trove Act, 1878",
                मराठी: "भारतीय खजिना कायदा, १८७८",
            },
            file: {
                English: demo3,
                मराठी: demo13,
            },
        },
        {
            id: 4,
            name: {
                English: "Right to Information Act, 2005",
                मराठी: "माहितीचा अधिकार कायदा, २००५",
            },
            file: {
                English: demo4,
                मराठी: demo14,
            },
        },
        {
            id: 5,
            name: {
                English: "The Antiquities and Art Treasures Act 1972",
                मराठी: "पुरातन वस्तू आणि कलासंपत्ती कायदा, १९७२",
            },
            file: {
                English: demo5,
                मराठी: demo15,
            },
        },
        {
            id: 6,
            name: {
                English: "The Maharashtra Ancient Monuments and Archaeological Sites and Remains Act, 1960",
                मराठी: "महाराष्ट्र प्राचीन स्मारके आणि पुरातत्त्व स्थळे व अवशेष अधिनियम, १९६०",
            },
            file: {
                English: demo6,
                मराठी: demo16,
            },
        },
    ];


    return (
        <div className="bg-[#F6F6EC] min-h-screen px-4 py-12">
            <div className="text-center mb-8">
                <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">
                    {t.title}
                </h1>
                <p className="font-futura tracking-wider text-sm sm:text-base lg:text-[15px] font-medium mt-2">
                    <span style={{ color: "#DD9827" }}>
                        <Link to="/" className="hover:underline">
                            {t.breadcrumb.home}
                        </Link>{" "}/{" "}</span>
                    {t.breadcrumb.page}
                </p>
            </div>

            {/* Download Title */}

            {/* Table Section */}
            <div className="max-w-5xl mx-auto overflow-x-auto">
                <div
                    className="bg-[#EFEDE0] rounded-xl overflow-hidden no-dark-bg"
                    style={{ border: "2px solid #F8D6BF" }}
                >
                    <table className="min-w-full text-center text-black text-sm sm:text-base">
                        <thead className='font-bold tracking-wide'
                            style={{
                                textShadow: '0.3px 0.3px 0 black',
                            }}>
                            <tr>
                                <th className="py-3 px-4 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                    {tableHeaders.srNo[selectedLang]}
                                </th>
                                <th className="py-3 px-4 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                    {tableHeaders.name[selectedLang]}
                                </th>
                                <th className="py-3 px-4" style={{ borderColor: '#F8D6BF' }}>
                                    {tableHeaders.download[selectedLang]}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {documents.map((doc, index) => (
                                <tr key={doc.id}
                                    className="hover:bg-[#F6F6EC]">
                                    <td className="py-3 px-4 border-t-2 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                        {selectedLang === 'मराठी' ? convertToMarathiNumber(index + 1) : `${index + 1}`}.
                                    </td>
                                    <td className="py-3 px-4 border-t-2 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                        {doc.name[selectedLang]}
                                    </td>
                                    <td className="py-3 px-4 border-t-2" style={{ borderColor: '#F8D6BF' }}>
                                        <div className="flex justify-center items-center h-full">
                                            <a
                                                href={doc.file[selectedLang]}
                                                download
                                                title={`Download PDF (${selectedLang})`}
                                                className="text-red-600 hover:text-red-800"
                                            >
                                                <FaFilePdf size={20} />
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    );
};

export default Actsandlaws;
